var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHidePassword = function SvgHidePassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#918F8F",
    d: "M1.179 9.515c.811-3.728 4.204-6.377 8.02-6.377s7.207 2.65 8.02 6.377a.57.57 0 0 0 .256.36.62.62 0 0 0 .448.082c.155-.03.29-.12.377-.245a.55.55 0 0 0 .085-.429C17.46 5.043 13.593 2 9.199 2S.937 5.043.013 9.283a.55.55 0 0 0 .084.429.6.6 0 0 0 .377.245c.155.03.316.002.448-.081a.57.57 0 0 0 .257-.36m8.008-4.1c1.104 0 2.164.42 2.945 1.167a3.9 3.9 0 0 1 1.22 2.817c0 1.057-.44 2.07-1.22 2.818a4.26 4.26 0 0 1-2.945 1.166 4.26 4.26 0 0 1-2.945-1.166 3.9 3.9 0 0 1-1.22-2.818c0-1.056.439-2.07 1.22-2.817a4.26 4.26 0 0 1 2.945-1.167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4E4E4E",
    d: "m2 1 14 14"
  })));
};
export default SvgHidePassword;